import { useNavigate, useLocation } from 'react-router-dom';

const mobileNavItems = [
  { label: 'Dashboard', path: '/', icon: 'ri-dashboard-3-line' },
  { label: 'Randevular', path: '/randevular', icon: 'ri-calendar-check-line' },
  { label: 'Müşteriler', path: '/musteriler', icon: 'ri-user-smile-line' },
  { label: 'Kasa', path: '/kasa', icon: 'ri-safe-2-line' },
  { label: 'Menü', path: '/menu-drawer', icon: 'ri-menu-4-line', isMenu: true },
];

interface MobileNavProps {
  onOpenDrawer: () => void;
}

export default function MobileNav({ onOpenDrawer }: MobileNavProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 h-16 flex items-center justify-around px-2"
      style={{
        background: 'var(--mobile-nav-bg)',
        borderTop: '1px solid var(--border-color)',
      }}
    >
      {mobileNavItems.map((item) => (
        <button
          key={item.label}
          onClick={() => {
            if (item.isMenu) {
              onOpenDrawer();
            } else {
              navigate(item.path);
            }
          }}
          className="flex flex-col items-center justify-center gap-1 py-1 px-3 rounded-lg transition-all cursor-pointer"
          style={{
            color: isActive(item.path) && !item.isMenu ? 'var(--gold)' : 'var(--text-muted)',
          }}
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className={`${item.icon} text-lg`} />
          </div>
          <span className="text-[10px] font-medium">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}